var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"year-picker"},[_c('section',[_c('b-field',{attrs:{"label":_vm.label}},[_c('b-select',{attrs:{"placeholder":"Select"},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}},_vm._l((_vm.years),function(y){return _c('option',{key:y,domProps:{"value":y}},[_vm._v(_vm._s(y))])}),0)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }